import { all, takeEvery, takeLatest, put, call, select } from 'redux-saga/effects';
import renderNotification from '../../helpers/notifications/renderNotification';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';
import { selectSelectedOrganizationId } from '../organizations/selectors';
import {
  onGetExternalContacts,
  onCreateExternalContact,
  onUpdateExternalContact,
  onDeleteExternalContact
} from './api';

import {
  getExternalContacts,
  getExternalContactsSucceeded,
  getExternalContactsFailed,
  createExternalContact,
  createExternalContactSucceeded,
  createExternalContactFailed,
  updateExternalContact,
  updateExternalContactSucceeded,
  updateExternalContactFailed,
  deleteExternalContact,
  deleteExternalContactSucceeded,
  deleteExternalContactFailed
} from './slice';

const { external_contact_create_success, external_contact_update_success, external_contact_delete_success } =
  NOTIFICATION_MESSAGES;

export function* getExternalContactsWorker({ payload = {} }) {
  const { organization_id } = payload;

  try {
    const response = yield call(onGetExternalContacts, { organization_id });
    yield put(getExternalContactsSucceeded(response.data));
  } catch {
    yield put(getExternalContactsFailed());
  }
}

export function* createExternalContactWorker({ payload }) {
  const { externalContact, callback } = payload;
  try {
    const response = yield call(onCreateExternalContact, externalContact);
    renderNotification({ type: 'success', message: external_contact_create_success });
    yield put(createExternalContactSucceeded(response.data));
    callback?.();
  } catch {
    yield put(createExternalContactFailed());
  }
}

export function* updateExternalContactWorker({ payload }) {
  const { externalContact, callback } = payload;
  try {
    const response = yield call(onUpdateExternalContact, externalContact);
    renderNotification({ type: 'success', message: external_contact_update_success });
    yield put(updateExternalContactSucceeded(response.data));
    callback?.();
  } catch {
    yield put(updateExternalContactFailed());
  }
}

export function* deleteExternalContactWorker({ payload }) {
  const { externalContact, callback } = payload;
  try {
    yield call(onDeleteExternalContact, externalContact);
    renderNotification({ type: 'success', message: external_contact_delete_success });
    yield put(deleteExternalContactSucceeded());
    callback?.();
  } catch {
    yield put(deleteExternalContactFailed());
  }
}

export function* getExternalContactsByOrganizationWorker() {
  const selectedOrganizationId = yield select(selectSelectedOrganizationId);
  if (selectedOrganizationId) {
    yield put(getExternalContacts({ organization_id: selectedOrganizationId }));
  }
}

export default function* externalContactsSaga() {
  yield all([
    takeLatest(getExternalContacts.type, getExternalContactsWorker),
    takeLatest(updateExternalContact.type, updateExternalContactWorker),
    takeLatest(createExternalContact.type, createExternalContactWorker),
    takeLatest(deleteExternalContact.type, deleteExternalContactWorker),

    takeEvery(
      [createExternalContactSucceeded.type, updateExternalContactSucceeded.type, deleteExternalContactSucceeded.type],
      getExternalContactsByOrganizationWorker
    )
  ]);
}
